import{__exports as r}from"../../../_virtual/object-get-own-property-symbols.js";var t;function e(){return t||(t=1,r.f=Object.getOwnPropertySymbols),r}export{e as __require};
//# sourceMappingURL=object-get-own-property-symbols.js.map
